import { deepCopy } from '../../../../../../shared/utils';
import {
  OMIT_FIELD,
  OPTIONAL_BRANCH_FIELD_OPTIONS,
  REQUIRED_BRANCH_FIELD_OPTIONS,
} from '../constants/costFileTemplateBranchFieldOptions';
import type { CostFileTemplateField } from '../types';

export class BranchFieldOptionService {
  private selectedValues: Set<string>;

  constructor(private mapping: CostFileTemplateField[]) {
    this.selectedValues = this.mapping.reduce((acc, field) => {
      if (this.isNotOmitted(field)) {
        acc.add(field.branchKeyOption.value);
      }
      return acc;
    }, new Set<string>());
  }

  private isNotOmitted(field: any): field is Required<CostFileTemplateField> {
    return field.branchKeyOption?.value && field.branchKeyOption?.value !== OMIT_FIELD.value;
  }

  getSelectedValues(fieldIndex?: number): Set<string> {
    const selectedValues = new Set([...this.selectedValues]);
    if (typeof fieldIndex !== 'number') {
      return selectedValues;
    }

    const field = this.mapping[fieldIndex];
    if (this.isNotOmitted(field)) {
      selectedValues.delete(field.branchKeyOption.value);
    }

    return selectedValues;
  }

  getRequiredOptions(fieldIndex?: number): any[] {
    const selectedValues = this.getSelectedValues(fieldIndex);
    return deepCopy(REQUIRED_BRANCH_FIELD_OPTIONS).map((option) => ({
      ...option,
      isDisabled: selectedValues.has(option.value),
    }));
  }

  getOptionalOptions(fieldIndex?: number): any[] {
    const selectedValues = this.getSelectedValues(fieldIndex);
    return deepCopy(OPTIONAL_BRANCH_FIELD_OPTIONS).map((option) => ({
      ...option,
      isDisabled: selectedValues.has(option.value),
    }));
  }
}
